module.exports = __webpack_public_path__ + "img/money-bag-icon.888e459b.svg";